import { injectIntl } from 'react-intl';
import Head from './Head';

const HeadWithIntl = injectIntl(Head);

HeadWithIntl.displayName = Head.displayName;

export default HeadWithIntl;
